<template>
    <div>
        <div id="container" v-if="flag">
            <swiper :options="mySwiperOption">
                <swiper-slide v-for=" i in mobile_banner" :key="i.id">
                    <img class="banimg" :src="i.src" width="100%" @click="onClick(i)" />
                    <div class="ban" v-if="i.id == 0" @click="loginIn(2)">
                        <div class="banner_text  center">
                            <p class="p1">提供优质服务</p>
                            <p class="p1">创造共同价值</p>
                        </div>
                        <div class="btn" @click="loginIn(2)">马上体验</div>
                    </div>
                    <div class="ban" v-if="i.id == 1">
                        <div class="banner_text  center">
                            <p class="p1">提供优质服务</p>
                            <p class="p1">创造共同价值</p>
                        </div>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <div id="container" v-if="!flag">
            <swiper :options="mySwiperOption">
                <swiper-slide v-for=" i in pc_banner" :key="i.id">
                    <img class="banimg" :src="i.src" width="100%" @click="onClick(i)" />
                    <div class="ban" v-if="i.id == 0">
                        <div class="banner_text  center">
                            <p class="p1">提供优质服务</p>
                            <p class="p1">创造共同价值</p>
                        </div>
                        <div class="btn" @click="loginIn(2)">马上体验</div>
                    </div>
                    <div class="ban" v-if="i.id == 1">
                        <div class="banner_text  center">
                            <p class="p1">提供优质服务</p>
                            <p class="p1">创造共同价值</p>
                        </div>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <div class="chain_info">
            <div class="l">
                <p>最新上链信息：</p>
                <el-table :data="tableData" stripe style="width: 100%;" :header-cell-style="{
                    color: '#000000',
                    fontSize: '14px',
                    opacity: '1',
                    height: '58px',
                }">
                    <el-table-column prop="chain_no" label="供应商编号">
                    </el-table-column>
                    <el-table-column prop="supply" label="供应商">
                    </el-table-column>
                    <el-table-column prop="buyer" label="采购商">
                    </el-table-column>
                    <!-- <el-table-column prop="itype" label="类型">
                        <template slot-scope="scope">
                            <span style="color: #165dff" v-if="scope.row.itype == 1">采购合同</span>
                            <span style="color: #165dff" v-if="scope.row.itype == 2">销售合同</span>
                            <span style="color: #165dff" v-if="scope.row.itype == 3">融资信息</span>
                            <span style="color: #165dff" v-if="scope.row.itype == 4">发票信息</span>
                            <span style="color: #165dff" v-if="scope.row.itype == 5">招投标信息</span>
                        </template>
</el-table-column> -->
                    <el-table-column prop="product_type" label="品类"> </el-table-column>
                    <el-table-column prop="create_time" label="上链日期"> </el-table-column>
                </el-table>
                <div class="chackmore" @click="loginIn(2)">查看更多></div>
            </div>
            <div class="r">
                <p>链上信息汇总：</p>
                <div class="chain_data">
                    <div class="box">
                        <div class="img"><img src="../assets/img_01.png" alt=""></div>
                        <div class="txt">
                            <div>
                                <p class="p1">上链企业</p>
                            </div>
                            <div>
                                <p class="p2">{{ upChainInfo.dept }}</p>
                                <p class="p3">个</p>
                            </div>
                        </div>
                    </div>
                    <div class="box">
                        <div class="img"><img src="../assets/img_02.png" alt=""></div>
                        <div class="txt">
                            <div>
                                <p class="p1">上链合同</p>
                            </div>
                            <div>
                                <p class="p2">{{ upChainInfo.contract }}</p>
                                <p class="p3">个</p>
                            </div>
                        </div>
                    </div>
                    <div class="box">
                        <div class="img"><img src="../assets/img_03.png" alt=""></div>
                        <div class="txt">
                            <div>
                                <p class="p1">上链权证</p>
                            </div>
                            <div>
                                <p class="p2">{{ upChainInfo.warrant }}</p>
                                <p class="p3">个</p>
                            </div>
                        </div>
                    </div>
                    <div class="box">
                        <div class="img"><img src="../assets/img_04.png" alt=""></div>
                        <div class="txt">
                            <div>
                                <p class="p1">融资总额度</p>
                            </div>
                            <div>
                                <p class="p2">{{ upChainInfo.quota }}</p>
                                <p class="p3">万</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="project_goin">
                    <div class="item_come">
                        <img class="img" src="../assets/img_004.png" alt="">
                        <div class="line"></div>
                        <div class="text">
                            <p class="p1">采购方入口</p>
                            <p class="p2">Purchaser's entrance</p>
                            <div class="btn" @click="loginIn(1)">立即进入</div>
                        </div>
                    </div>
                    <div class="item_come">
                        <img class="img" src="../assets/img_005.png" alt="">
                        <div class="line"></div>
                        <div class="text">
                            <p class="p1">供应商入口</p>
                            <p class="p2">Supplier portal</p>
                            <div class="btn" @click="loginIn(2)">立即进入</div>
                        </div>
                    </div>
                    <div class="item_come">
                        <img class="img" src="../assets/img_006.png" alt="">
                        <div class="line"></div>
                        <div class="text">
                            <p class="p1">银行方入口</p>
                            <p class="p2">bank entrance</p>
                            <div class="btn" @click="loginIn(3)">立即进入</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="new_place">
            <p class="p1">解决方案</p>
            <p class="p1">Solution</p>
            <div class="newlist">
                <div class="l">
                    <img class="picture1" src="../assets/img_007.png" alt="图片">
                    <p class="title">信息共享</p>
                    <p class="text_new">
                        聚焦建材行业面临的难点、痛点问题，
                        以互联网为载
                        体，融合区块链、大数据
                        等新一代信息技术，打通建材供应链上
                        的商
                        流、信息流、资金流、物流，实现
                        产业链上所有资源的协同共享与优化配
                        置、产业全流程的可视与可控。
                    </p>
                </div>
                <div class="l">
                    <img class="picture2" src="../assets/img_008.png" alt="图片">
                    <p class="title">风险防控</p>
                    <p class="text_new">
                        通过各个业务平台的真实自动上链技术，
                        有效防止虚
                        假信息的产生。不仅确保了
                        供应链信息的安全性，还保护了所有相
                        关方的利益，大幅降低了因信息不实导
                        致的风险。
                    </p>
                </div>
                <div class="l">
                    <img class="picture3" src="../assets/img_009.png" alt="图片">
                    <p class="title">数据增信</p>
                    <p class="text_new">
                        基于区块链技术对线上招采、电子签约、
                        智慧物流、智能收验等
                        建材供应链全链
                        路数据进行上链存证，营造“链上可信”
                        的平台环境，
                        向供应商上游提供线上化、
                        多元化的供应链数据增信服务，助力解决
                        供应链上下游企业支付方式单一、中小供
                        应商融资难、成本高的难题。
                    </p>
                </div>
            </div>
        </div>
        <div class="product_peculiarity">
            <p class="p1">产品特点</p>
            <p class="p1">Product features</p>
            <div class="list_of_peculiarity">
                <div class="product_list">
                    <div class="tip">
                        <img src="../assets/img_05.png" alt="">
                    </div>
                    <div class="txt">
                        <p class="t1">额度高</p>
                        <p class="t2">且额度循环使用</p>
                    </div>

                </div>
                <div class="product_list">
                    <div class="tip">
                        <img src="../assets/img_06.png" alt="">
                    </div>
                    <div class="txt">
                        <p class="t1">放款快</p>
                        <p class="t2">当日即可完成审批</p>
                    </div>
                </div>
                <div class="product_list">
                    <div class="tip">
                        <img src="../assets/img_07.png" alt="">
                    </div>
                    <div class="txt">
                        <p class="t1">无抵押</p>
                        <p class="t2">无需提供抵押物</p>
                    </div>
                </div>
                <div class="product_list">
                    <div class="tip">
                        <img src="../assets/img_08.png" alt="">
                    </div>
                    <div class="txt">
                        <p class="t1">无手续费</p>
                        <p class="t2">随借随还，按日计息</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="aboutUs">
            <div class="r">
                <p class="p2">jiancaideyiwang</p>
                <p class="p1">关于我们</p>
                <p class="p1">About Us</p>
                <p class="p3"> 增信板块聚焦数字化服务，以数据技术、物联网、区块链等时代前沿技术为核心，服务产业和推进企业供应链发展。
                    通过对建材贸易全链路数据进行上链存证，营造“链上可信”的平台环境，并链接各大银行端系统，为供应链上游提供高效、便捷、
                    低成本的供应链数据增信服务，润滑产业链条的流畅运转。
                </p>

            </div>
            <div class="l"><img src="../assets/aboutus.png" alt=""></div>
        </div>
        <!-- <div class="new_module">
            <div class="l">
                <div class="flex">
                    <div>
                        <p class="p1">新闻动态</p>
                        <p class="p1">News</p>
                    </div>
                    <div>
                        <div class="more" @click="checkMore">查看更多
                            <div class="arrow"></div>
                        </div>
                    </div>
                </div>
                <div class="new_list" v-for="(item, index) in newList" :key="index" @click="toDetailPage(item.id)">
                    <div class="lt">
                        <p class="num">{{ item.year }}</p>
                        <p class="num2">{{ item.day }}</p>
                        <div class="rectangle"></div>
                    </div>
                    <div class="rt">
                        <p class="title">{{ item.title }}</p>
                        <p class="desc">{{ item.introduction }}</p></div>
                </div>
            </div>
            <div class="l2">
                <div class="project_goin">
                    <div class="item_come">
                        <img class="img" src="../assets/img_004.png" alt="">
                        <div class="line"></div>
                        <div class="text">
                            <p class="p1">采购方入口</p>
                            <p class="p2">Purchaser's entrance</p>
                            <div class="btn" @click="loginIn(1)">立即进入</div>
                        </div>
                    </div>
                    <div class="item_come">
                        <img class="img" src="../assets/img_005.png" alt="">
                        <div class="line"></div>
                        <div class="text">
                            <p class="p1">供应商入口</p>
                            <p class="p2">Supplier portal</p>
                            <div class="btn" @click="loginIn(2)">立即进入</div>
                        </div>
                    </div>
                    <div class="item_come">
                        <img class="img" src="../assets/img_006.png" alt="">
                        <div class="line"></div>
                        <div class="text">
                            <p class="p1">银行方入口</p>
                            <p class="p2">bank entrance</p>
                            <div class="btn" @click="loginIn(3)">立即进入</div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="partners">
            <p class="lab">合作伙伴</p>
            <p class="lab">Partner</p>
            <!-- <p class="lab2">详细、全面的产品架构让您在使用时更加方便</p> -->
            <div class="partnersList">
                <div>
                    <img src="../assets/bank_img1.png" alt="" />
                </div>
                <div>
                    <img src="../assets/bank_img2.png" alt="">
                </div>
                <div>
                    <img src="../assets/bank_img3.png" alt="">
                </div>
                <div>
                    <img src="../assets/bank_img4.png" alt="" />
                </div>
                <div>
                    <img src="../assets/bank_img5.png" alt="" />
                </div>
                <div>
                    <img src="../assets/bank_img6.png" alt="" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// 引入基本模板
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/bar");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
import {
    getOnlineInfo,
    getsupplier,
    getcontract,
    getcertificate,
    getReceipt,
    getNews,
    getuploadImg,
    initData
} from "@/api/api";
var check = require("../utils/utils.js");
import {
    swiper,
    swiperSlide
} from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
    data() {
        let _this = this;
        return {
            options: [
                {
                    id: 1,
                    tag: "采购合同",
                },
                {
                    id: 2,
                    tag: "销售合同",
                },
                {
                    id: 3,
                    tag: "融资信息",
                },
                {
                    id: 4,
                    tag: "发票信息",
                },
                {
                    id: 5,
                    tag: "招投标信息",
                },
            ],
            currentPage1: 1,
            pagesize: 10,
            total: 10,
            chainInfo: {
                gyl: "",
                supplier: "",
                contract: "",
                invoice: "",
                certificate: "",
                blockheight: "",
                blocktime: "",
                totaldatavolume: "",
                datavolumeinthelastthreedays: "",
                numberofaddresses: ""
            },
            lastTime: "",
            tableData: [],
            upChainInfo: {
                dept: '0',
                contract: '0',
                warrant: '0',
                quota: '0'
            },
            price: [],
            newList: [],
            mySwiperOption: {
                pagination: {
                    el: '.swiper-pagination', //与slot="pagination"处 class 一致
                    clickable: true, //轮播按钮支持点击
                },
                //自动播放
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                //循环
                loop: true,
            },
            pc_banner: [
                {
                    id: 0,
                    src: require("@/assets/jiancaideBanner.png"),
                },
                {
                    id: 1,
                    src: require("@/assets/jiancaideBanner.png"),
                },
            ],
            mobile_banner: [
                {
                    id: 0,
                    src: require("@/assets/jiancaideBanner.png"),
                },
                {
                    id: 1,
                    src: require("@/assets/jiancaideBanner.png"),
                },
            ],
            banner: [],
            flag: false,
        };
    },
    components: {
        // 注册 vue-awesome-swiper 组件
        swiper,
        swiperSlide
    },
    mounted() {
        getOnlineInfo().then((res) => {
            // console.log("最新上链信息------",res);
            this.tableData = res.data;
        });
        this.getInitData();
        // this.getNewAll()
        this.flag = this.isMobile()
    },
    methods: {
        isMobile() {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            // 使用正则表达式判断是否为移动设备
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
                return true; // 是移动端
            }
            return false; // 是PC端
        },
        onClick(i) {
            console.log(i.id)
        },
        // handleClickCard(e) {
        //     let cardDataJSON = e.target.getAttribute('data-card')
        //     console.log(e.target.dataset.card, e.target.getAttribute('data-card'))
        //     let cardData = JSON.parse(cardDataJSON)
        //     console.log(cardData)
        // },
        // toNewPage(id){
        //     console.log(id)
        // },
        getInitData() {
            getInit().then((res) => {
                // console.log("初始化数据------",res);
                this.banner = res.data.banner;
            });
        },

        loginIn(e) {
            if (e == 1) {
                window.open('https://psp.jiancaideyi.com')
            } else if (e == 2) {
                window.open('https://ssp.jiancaideyi.com')
            } else if (e == 3) {
                // this.$message('暂未开放')
                window.open('https://bsp.jiancaideyi.com')
            }
        },
        getInitData() {
            initData().then(res => {
                // console.log(res)
                let form = res.data.data[0]
                const flag = form.is_open
                if (flag) {
                    this.upChainInfo.dept = form.enterprise
                    this.upChainInfo.contract = form.contract
                    this.upChainInfo.warrant = form.cert
                    this.upChainInfo.quota = form.limit
                } else {
                    this.getTableInfo()
                }
            })
        },
        getTableInfo() {
            getsupplier().then((res) => {
                // console.log("1获取上链信息------",res)
                this.upChainInfo.dept = res.data
            })
            getcontract().then((res) => {
                // console.log("2获取上链信息------",res)
                this.upChainInfo.contract = res.data
            })
            getcertificate().then((res) => {
                // console.log("3获取上链信息------",res)
                this.upChainInfo.warrant = res.data
            })
            getReceipt().then((res) => {
                // console.log("4获取上链信息------",res)
                this.upChainInfo.quota = res.data
            })
        },

        getNewAll() {
            getNews().then((res) => {
                // console.log("new----", res)
                this.newList = res.data.data.slice(0, 4)
                for (let i = 0; i < this.newList.length; i++) {
                    getuploadImg(this.newList[i].title_avatar).then(res => {
                        this.$set(this.newList[i], 'pic', res.data.content)
                    })
                    this.newList[i].create_datetime = this.newList[i].create_datetime.slice(0, 10)
                    this.$set(this.newList[i], 'year', this.newList[i].create_datetime.slice(0, 7))
                    this.$set(this.newList[i], 'day', this.newList[i].create_datetime.slice(8, 10))
                    // console.log(this.newList)

                }
            })
        },
        // toprovider() {
        // window.open("http://49.233.123.55:1" + val + "025")
        // },
        checkMore() {
            // this.tab = "/home";
            this.$router.push("/home");
        },

        toDetailPage(id) {
            this.$router.push({
                name: 'NewDetail',
                query: { id: id }
            })
        },
    },
};
</script>
<style scoped lang="scss">
.swiper-pagination {
    width: 32%;
    margin: 0 auto 42px;

}

//圆点变横线，修改背景色
::v-deep .swiper-pagination-bullet {
    width: 60px;
    height: 5px;
    border-radius: 0px;
    background: rgba(255, 255, 255, 0.5);
    opacity: 1;
}

//修改选中的颜色
::v-deep .swiper-pagination-bullet-active {
    background-color: #ffffff;
}

//修改边距
::v-deep .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 4px 20px;
}

.banimg {
    width: 100%;
    height: 600px;
    position: relative;
}

.ban {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;

    .banner_text {
        position: absolute;
        top: 211px;
        left: 12%;
        text-align: left;

        .p1 {
            font-size: 56px;
            color: #FFFFFF;
            font-weight: 500;
            // font-family: 'CustomFont', sans-serif;
        }

        .p1:last-child {
            margin-top: 10px;
            text-indent: 1em;
        }

    }

    .btn {
        width: 213px;
        height: 62px;
        border-radius: 4px;
        opacity: 1;
        background: #004FC6;
        font-size: 18px;
        color: #FFFFFF;
        text-align: center;
        line-height: 62px;
        cursor: pointer;
        position: absolute;
        top: 411px;
        left: 15%;
    }

}

@media screen and (max-width: 750px) {
    .banimg {
        width: 100%;
        height: 400px;
        margin-top: 206px;
        position: relative;
    }

    .ban {
        height: 400px;
        width: 100%;
        position: absolute;
        margin-top: 206px;

        .banner_text {
            position: absolute;
            top: 10%;
            left: 12%;
            text-align: left;

            .p1 {
                font-size: 56px;
                color: #FFFFFF;
                font-weight: 500;
                // font-family: 'CustomFont', sans-serif;
            }

            .p1:last-child {
                margin-top: 10px;
                text-indent: 1em;
            }

        }

        .btn {
            position: absolute;
            top: 60%;
            left: 20%;
            width: 120px;
        }
    }


}

.chain_info {
    display: flex;
    height: 1254px;
    margin-top: -5px;

    .l {
        width: 75%;
        padding: 56px 120px;
        box-sizing: border-box;

        p {
            text-align: left;
            color: #2170CE;
            font-size: 20px;
            font-weight: 400;
        }

        .table-style {
            margin-top: 32px;
            // height: 521px;
            margin-bottom: 22px;
            background-color: #004FC6;
        }

        .chackmore {
            display: flex;
            justify-content: flex-end;
            line-height: 36px;
            cursor: pointer;
        }

    }

    .r {
        width: 25%;
        background-color: #004FC6;
        padding: 28px 66px;
        box-sizing: border-box;

        p {
            text-align: left;
            color: #ffffff;
            font-size: 20px;
            font-weight: 400;
        }

        .chain_data {
            .box {
                width: 100%;
                padding: 18px 20px;
                box-sizing: border-box;
                border-radius: 86px;
                background-color: #FFFFFF;
                display: flex;
                margin: 35px auto;


                .img {
                    width: 54px;
                    height: 54px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .txt {
                    margin-left: 29px;

                    div {
                        display: flex;
                        align-items: center;
                    }

                    .p1 {
                        color: #1D2129;
                        font-size: 20px;
                    }

                    .p2 {
                        color: #1D2129;
                        font-size: 40px;

                    }

                    .p3 {
                        color: #4E5969;
                        font-size: 16px;
                        margin-left: 43px;

                    }
                }
            }
        }

        .project_goin {
            .item_come {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 166px;
                margin: 15px auto;

                .img {
                    width: 120px;
                    height: 120px;

                }

                .line {
                    height: 100%;
                    width: 1px;
                    background-color: #ffffff;
                    opacity: 0.1;

                }

                .text {
                    width: 45%;

                    .p1 {
                        font-size: 24px;
                        font-weight: 500;
                        line-height: 34px;
                        text-align: left;

                    }

                    .p2 {
                        font-size: 14px;
                        font-weight: 500;
                        line-height: 20px;
                        text-align: left;

                    }

                    .btn {
                        width: 120px;
                        height: 36px;
                        border-radius: 4px;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 36px;
                        text-align: center;
                        background-color: #ffffff;
                        color: #004FC6;
                        margin-top: 35px;
                        cursor: pointer;


                    }

                }

            }
        }
    }
}

@media screen and (max-width: 750px) {
    .chain_info {
        flex-direction: column;
        height: 2508px;

        .l {
            width: 100%;
            padding: 20px;
        }

        .r {
            width: 100%;
            padding: 28px 126px;
        }
    }
}


.new_place {
    background: url(../assets/solution.png) no-repeat;
    background-size: 100%;
    padding: 106px 256px 170px 228px;
    box-sizing: border-box;

    .p1 {
        font-size: 48px;
        font-weight: 600;
        color: #ffffff;
        line-height: 60px;
        text-align: left;
    }

    .p2 {
        font-size: 14px;
        line-height: 26px;
        color: #808080;
        margin-top: 10px;
    }

    .newlist {
        width: 100%;
        margin: 122px auto;
        display: flex;
        justify-content: space-between;

        .l {
            width: 20%;
            height: 100%;

            img {
                width: 109px;
                height: 124px;
                float: left;
            }

            .title {
                clear: both;
                font-size: 24px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 85px;
                text-align: left;
            }

            .text_new {
                font-size: 16px;
                line-height: 23px;
                text-align: left;
                color: #F2F2F2;

            }

        }

        // .l:hover {
        //     background-color: #233B83;

        //     .picture1 {
        //         content: url("../assets/icon_04.png");
        //     }

        //     .picture2 {
        //         content: url("../assets/icon_05.png");
        //     }

        //     .picture3 {
        //         content: url("../assets/icon_06.png");
        //     }

        //     .title,
        //     .text_new {
        //         color: #ffffff;
        //     }
        // }
    }
}

@media screen and (max-width: 750px) {
    .new_place {
        padding: 40px 30px;
        margin-top: 50px;
        height: 1280px;
        background-repeat: repeat;

        .newlist {
            width: 100%;
            flex-direction: column;

            .l {
                width: 100%;
                margin: 20px auto;
            }
        }

    }
}

.product_peculiarity {
    background-color: #ffffff;
    padding: 125px 224px 262px 224px;
    box-sizing: border-box;

    .p1 {
        font-size: 48px;
        font-weight: 500;
        color: #000000;
        line-height: 60px;
        text-align: left;
    }

    .p2 {
        font-size: 14px;
        line-height: 26px;
        color: #808080;
        margin-top: 10px;
        margin-bottom: 70px;
    }

    .list_of_peculiarity {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 140px;

    }

    .product_list {
        display: flex;

        .tip {
            width: 138px;
            height: 136px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .txt {
            margin-left: 30px;
            text-align: left;

            .t1 {
                font-size: 32px;
                font-weight: 700;
                color: #000000;
                line-height: 66px;
            }

            .t2 {
                font-size: 16px;
                font-weight: 700;
                color: #888888;
                line-height: 60px;


            }
        }


    }
}

@media screen and (max-width: 750px) {
    .product_peculiarity {
        width: 100%;
        padding: 40px 30px;

        .list_of_peculiarity {
            flex-wrap: wrap;
            flex-direction: column;
            margin-top: 60px;

            .product_list {
                margin: 35px auto;
                align-items: center;
            }
        }

    }
}

.new_module {
    width: 100%;
    height: 910px;
    background-color: #FFFFFF;
    display: flex;

    .l {
        width: 65%;
        height: 100%;
        text-align: left;
        padding: 140px 99px 99px 224px;
        box-sizing: border-box;

        img {
            width: 100%;
            height: 100%;
        }

        .p1 {
            font-size: 45px;
            font-weight: 600;
            color: #000000;
            line-height: 60px;
        }

        .p2 {
            font-size: 14px;
            line-height: 26px;
            color: #808080;

        }

        .new_list {
            display: flex;
            margin: 24px auto;
            height: 100px;

            .lt {
                width: 100px;
                height: 100%;
                box-shadow: 0px 4px 12px 0px #0A1F481A;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                position: relative;

                .num {
                    font-size: 14px;
                    color: #161616;
                    font-weight: 500;
                    margin-top: 20px;
                }

                .num2 {
                    color: #004FC6;
                    font-size: 40px;
                    font-weight: 700;
                }

                .rectangle {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 50px;
                    height: 50px;
                    border-top: 1px solid #004FC6;
                    border-left: 1px solid #004FC6;
                }
            }

            .rt {
                width: 80%;
                height: 100px;
                margin-left: 20px;

                .title {
                    font-size: 18px;
                    font-weight: 500;
                    color: #3D3D3D;
                    line-height: 50px;

                }

                .desc {
                    font-size: 14px;
                    line-height: 26px;
                    color: #808080;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    text-overflow: ellipsis;
                }
            }


        }

        .more {
            font-size: 18px;
            color: #00000073;
            cursor: pointer;
            // display: flex;
            // align-items: center;

            .arrow {
                position: relative;
                display: inline-block;
                width: 10px;
                height: 20px;

            }

            .arrow::after {
                content: "";
                position: absolute;
                top: 6px;
                left: 3px;
                border-top: 6px solid transparent;
                border-bottom: 6px solid transparent;
                border-left: 8px solid #00000073;
                /* 设置边框样式为向右的三角形 */
            }
        }
    }

    .l2 {
        width: 35%;
        padding: 170px 249px 38px 60px;
        box-sizing: border-box;
        background-color: #004FC6;

        .project_goin {
            .item_come {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 166px;
                margin: 15px auto;

                .img {
                    width: 120px;
                    height: 120px;

                }

                .line {
                    height: 100%;
                    width: 1px;
                    background-color: #ffffff;
                    opacity: 0.1;

                }

                .text {
                    width: 45%;

                    .p1 {
                        font-size: 24px;
                        font-weight: 500;
                        line-height: 34px;
                        text-align: left;
                        color: #ffffff;

                    }

                    .p2 {
                        font-size: 14px;
                        font-weight: 500;
                        line-height: 20px;
                        text-align: left;
                        color: #ffffff;


                    }

                    .btn {
                        width: 120px;
                        height: 36px;
                        border-radius: 4px;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 36px;
                        text-align: center;
                        background-color: #ffffff;
                        color: #004FC6;
                        margin-top: 35px;
                        cursor: pointer;


                    }

                }

            }
        }
    }
}

@media screen and (max-width: 750px) {
    .new_module {
        height: 1390px;
        flex-direction: column;

        .l {
            width: 100%;
            height: 695px;
        }

        .l2 {
            padding: 50px 60px;
        }

    }
}

.aboutUs {
    width: 100%;
    height: 664px;
    // background-image: url(../assets/bg_img.png);
    // background-repeat: no-repeat;
    // background-position: 100%;
    display: flex;
    // margin-bottom: 50px;

    .l {
        width: 54%;
        height: 100%;

        img {
            width: 100%;
            height: 100%;

        }
    }

    .r {
        width: 46%;
        padding: 124px 150px 180px 220px;
        box-sizing: border-box;
        text-align: left;
        background-color: #004FC6;

        .p1 {
            font-size: 48px;
            font-weight: 600;
            color: #ffffff;
            line-height: 60px;

        }

        .p2 {
            font-size: 14px;
            line-height: 26px;
            color: #FFFFFF;
            opacity: 0.45;
            margin-bottom: 27px;
        }

        .p3 {
            font-size: 16px;
            font-weight: 500;
            line-height: 32px;
            color: #FFFFFF;
            text-indent: 2em;
            margin-top: 40px;

        }
    }
}

@media screen and (max-width: 750px) {
    .aboutUs {
        flex-direction: column;
        height: 1328px;
        justify-content: space-between;

        .l {
            width: 100%;
            height: 50%;
        }

        .r {
            width: 100%;
            height: 50%;
            padding: 120px;

        }

    }
}

.partners {
    width: 100%;
    padding: 180px 224px;
    box-sizing: border-box;

    .lab {
        font-size: 48px;
        font-weight: 600;
        line-height: 60px;
        color: #000000;
        text-align: left;
    }

    .lab2 {
        font-size: 14px;
        line-height: 26px;
        color: #808080;
        margin-top: 10px;
    }

    .partnersList {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin: 60px auto 34px;

        div {
            width: 33%;
            height: auto;
            border-radius: 20px;
            background: #ffffff;
            display: flex;
            align-items: center;
        }

        img {
            width: 100%;
            height: auto;
            margin: auto;
            // display: flex;
            // justify-content: space-between;
            // flex-wrap: wrap;
        }
    }
}

@media screen and (max-width: 750px) {
    .partners {
        width: 100%;
        padding: 40px 30px;

        .lab {
            font-size: 38px;
        }

        .partnersList {
            justify-content: space-between;
            flex-wrap: wrap;

            div {
                width: 49%;
                margin-bottom: 20px;
                overflow: hidden;
                // border: 1px solid #aaa9a9;

                img {
                    width: 100%;
                }
            }

        }
    }
}

::v-deep .el-table,
::v-deep .el-table__expanded-cell {
    // font-size: 22px;
    font-weight: 600;
    background-color: transparent !important;
    // border: 1px solid #EBEEF5;
}

::v-deep .el-table .cell {
    // line-height: 68px;
}

::v-deep .el-table tr {
    background-color: transparent !important;
    height: 68px;
    color: #141E43;
    font-size: 16px;
    font-weight: 400;
}

::v-deep .el-table::before {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0px;
}

::v-deep .el-pagination .btn-prev span,
::v-deep .el-pagination .btn-next span {
    display: inline-block;
    line-height: 32px;
}

::v-deep .el-pagination .btn-next {
    padding-left: 0;
}

::v-deep .el-pager li {
    background: transparent;
    color: #1d2129;
    min-width: 0;
    margin: 0 10px;
}

::v-deep .el-pager {
    margin: 0 10px;
}

::v-deep .el-pager li.active {
    width: 32px;
    height: 32px;
    background: #e8f4ff;
    border-radius: 2px;
    color: #1664ff;
}

::v-deep .el-pagination__total {
    color: #898989;
}
</style>